import { createFileRoute } from '@tanstack/react-router'
import SettingsExtruct from '@/features/settings/extruct'

export const Route = createFileRoute('/_authenticated/settings/extruct')({
  component: SettingsExtruct,
})
